import * as OBC from "@thatopen/components";
import * as OBCF from "@thatopen/components-front";
import { FragmentIdMap } from "@thatopen/fragments";
import * as THREE from "three";
export const InitializeViewer = (setCameraPosition: (data: any) => void) => {
    const container = document.getElementById("container")!;

    const components = new OBC.Components();
    // setComponentsState(components);
    const worlds = components.get(OBC.Worlds);

    const world = worlds.create<
        OBC.SimpleScene,
        OBC.SimpleCamera,
        OBCF.PostproductionRenderer
    >();

    world.scene = new OBC.SimpleScene(components);
    world.renderer = new OBCF.PostproductionRenderer(components, container);
    world.camera = new OBC.SimpleCamera(components);

    components.init();

    world.camera.controls.setLookAt(12, 6, 8, 0, 0, -10);

    world.scene.setup();
    // setWorldState(world);
    // const grids = components.get(OBC.Grids);
    // const grid = grids.create(world);
    world.scene.three.background = null;
    
    world.camera.three.near = 0.1; // Set a reasonable near clipping plane
    world.camera.three.far = 1000000; // Set a reasonable far clipping plane
    world.camera.three.updateProjectionMatrix();
    world.camera.updateAspect();
    // world.camera.controls.orbi
    world.renderer.postproduction.enabled = true;
    // world.renderer.postproduction.customEffects.excludedMeshes.push(grid.three);
    const fragmentIfcLoader = components.get(OBC.IfcLoader);
    fragmentIfcLoader.setup().then(() => {
        fragmentIfcLoader.settings.webIfc.COORDINATE_TO_ORIGIN = true;
        // loadIfc(fragmentIfcLoader, world);
    })
    world.camera.controls.addEventListener('update', () => {
        let cameraPositionOut: any;
        const position = world.camera.controls.getPosition(cameraPositionOut);

        setCameraPosition({ x: position.x, y: position.y, z: position.z });

    });
    world?.renderer?.three.setClearColor('#FFFFFF');
    const highlighter = components.get(OBCF.Highlighter);
    highlighter.setup({ world });
    highlighter.zoomToSelection = true;
    const outliner = components.get(OBCF.Outliner);
    outliner.world = world;
    outliner.enabled = true;

    outliner.create(
        "example",
        new THREE.MeshBasicMaterial({
            color: 0xbcf124,
            transparent: true,
            opacity: 0.5,
        }),
    );

    highlighter.events.select.onHighlight.add((data: FragmentIdMap) => {
        outliner.clear("example");
        outliner.add("example", data);
        console.log('highlighted', data);

    });

    highlighter.events.select.onClear.add(() => {
        outliner.clear("example");
    });

    return { world, components, highlighter };


}